module.exports = __webpack_public_path__ + "static/media/emoji-laugh-svgrepo-com.d28f8109.svg";